import { Component } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import moment from 'moment';
import { MostrarMensajeErrorAction } from 'src/app/@store/actions';
import { AppState } from 'src/app/@store/app.reducers';
import { ComplementoWebService } from 'src/app/services/complemento-web/complemento-web.service';
import { ConsultaFechasOutput } from 'src/app/models/complementos-web/complementos-web.model';
import { MatFormField, MatLabel, MatSuffix, MatHint, MatPrefix, MatError } from '@angular/material/form-field';
import { MatSelect, MatOption } from '@angular/material/select';
import { TitleCasePipe } from '@angular/common';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { InputFechaActualizacionComponent } from '../../../../@theme/@components/input-fecha-actualizacion/input-fecha-actualizacion.component';
import { MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';

@Component({
    selector: 'app-form-busqueda-consulta',
    templateUrl: './form-busqueda-consulta.component.html',
    styleUrls: ['./form-busqueda-consulta.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatSelect, MatOption, MatIconButton, MatSuffix, MatIcon, MatHint, InputFechaActualizacionComponent, MatDatepickerToggle, MatPrefix, MatDatepicker, MatError, TitleCasePipe]
})
export class FormBusquedaConsultaComponent {

  public catalogos = {
    catEstatus: [
      { id: 0, nombre: 'TODOS' },
      { id: 1, nombre: 'CERRADO' },
      { id: 4, nombre: 'ABIERTO' },
    ],
    catOficinas: [
      { id: 0, nombre: 'TODAS' },
      { id: "FRN", nombre: 'FORANEAS' },
      { id: "D00", nombre: 'LOCAL' },
    ]
  };
  public detalleFechasBusqueda : ConsultaFechasOutput;

  public listObservables = new Subscription();
  public formSiniestrosConsulta: FormGroup;

  constructor(
    private store: Store<AppState>,
    private complementoWebService: ComplementoWebService
  ) {
    this.cargarFormulario();
  }

  ngOnDestroy(): void {
    this.listObservables.unsubscribe();
  }

  ngOnInit(): void {
    this.consultarRangoFechas();
  }

  public cargarFormulario() {
    this.formSiniestrosConsulta = new FormGroup({
      fechaRegistroInicial: new FormControl(null),
      fechaRegistroFinal: new FormControl(null),
      idEstatus: new FormControl(4),
      idOficina: new FormControl(0),
      sucursal: new FormControl(null),
      consecutivo: new FormControl(null),
      anio: new FormControl(null),
    }, { validators: this.dateRangeValidator });
  }

  public dateRangeValidator(group: AbstractControl) {
    const startDateStr = group.get('fechaRegistroInicial')?.value;
    const endDateStr = group.get('fechaRegistroFinal')?.value;
    if (startDateStr && endDateStr) {
      const startDate = new Date(startDateStr);
      const endDate = new Date(endDateStr);

      if (startDate > endDate) {
        return { dateRangeInvalid: true };
      }
    }
    return null;
  }

  consultarRangoFechas() {
    const request = {
      diasAtras: 1
    }
    this.complementoWebService.consultaFechas(request).subscribe({
      next: (value) => {
        const fechaInicio = moment(value.Resultado.FechaInicio, "DD/MM/YYYY").format("YYYY-MM-DD");
        const fechaTermino = moment(value.Resultado.FechaTermino, "DD/MM/YYYY").format("YYYY-MM-DD");
        this.formSiniestrosConsulta.get('fechaRegistroInicial').setValue(fechaInicio);
        this.formSiniestrosConsulta.get('fechaRegistroFinal').setValue(fechaTermino);

        this.detalleFechasBusqueda = value.Resultado;
      },
      error: (err) => {
        this.formSiniestrosConsulta.get('fechaRegistroInicial').setValue(moment().subtract(request.diasAtras, 'days').format("YYYY-MM-DD"));
        this.formSiniestrosConsulta.get('fechaRegistroFinal').setValue(moment().format("YYYY-MM-DD"));
      },
    })
  }
}
